export default "__VITE_ASSET__CQ2J03wo__"